import React, { useState } from 'react';
import { Div, DivProps, Heading, Button } from '@kizi/core-components';
import { Desktop } from '../../utils/breakpoint';
import { useForms } from '@kizi/comparator-core';

export interface WidgetDataContentProps {}

export interface PersonalDataHandlerProps extends DivProps {
  title: string;
  formFields: React.ReactNode;
  dataTemplate: React.ReactNode;
  extraContent?: React.ReactNode;
  editData?: boolean;
  onCancel: () => void;
  forms: string[];
}

const Flex = (props) => <Div display="flex" width="100%" {...props} />;

const ButtonComp = (props) => (
  <Button variant="transparent" mt={3} fontSize={[2, 3]} {...props}>
    {props.children}
  </Button>
);

export interface SubmitMultipleFormsButtonProps {
  forms: string[];
  onClick: () => void;
}

const SubmitMultipleFormsButton: React.FC<SubmitMultipleFormsButtonProps> = (
  props
) => {
  const forms = useForms(props.forms);
  if (!forms || forms.length === 0) return null;
  const enabled = forms.every((form) => form.state.value === 'completed');
  return (
    <ButtonComp disabled={!enabled} variant="primary" width="auto" {...props}>
      Opslaan
    </ButtonComp>
  );
};

export const PersonalDataHandler: React.FC<PersonalDataHandlerProps> =
  React.forwardRef<HTMLDivElement, PersonalDataHandlerProps>(
    (
      { title, dataTemplate, extraContent, formFields, onCancel, forms },
      ref
    ) => {
      const [showForm, setShowForm] = useState(false);

      const toggleForm = () => {
        setShowForm(!showForm);
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      };

      const handleSubmit = () => {
        toggleForm();
      };

      const dataContainer = (
        <>
          <Flex flexDirection="column">
            <Desktop>
              <Heading variant="H4" as="h4" color="main.2" m={0} mb={3}>
                {title}
              </Heading>
            </Desktop>
            {dataTemplate}
          </Flex>
          <ButtonComp onClick={() => setShowForm(!showForm)}>Wijzig</ButtonComp>
          {extraContent}
        </>
      );

      const toggleContent = (editForm) => {
        return editForm ? (
          formContent
        ) : (
          <Flex flexDirection={'column'} alignItems="flex-start" ref={ref}>
            {dataContainer}
          </Flex>
        );
      };

      const handleCancel = () => {
        onCancel();
        toggleForm();
      };

      const formContent = (
        <Flex flexDirection="column" ref={ref}>
          <Desktop>
            <Heading variant="H4" as="h4" color="main.2" m={0} mb={6}>
              {title}
            </Heading>
          </Desktop>

          {formFields}

          <Flex flexDirection="row" justifyContent="space-between" mt={3}>
            <SubmitMultipleFormsButton onClick={handleSubmit} forms={forms} />
            <ButtonComp onClick={handleCancel}>Annuleren</ButtonComp>
          </Flex>
        </Flex>
      );

      return toggleContent(showForm);
    }
  );
